export default [
  {
    id: 152252,
    code: 'standard',
    cost: 0,
    currency: 'USD',
    selected: true,
    range: {
      min: 7,
      max: 8,
      verb: 'arrive',
      unit: 'business_days',
    },
  },
  {
    id: 152253,
    code: 'two_day',
    cost: 5,
    currency: 'USD',
    selected: false,
    range: {
      min: 2,
      max: 3,
      verb: 'arrive',
      unit: 'business_days',
    },
  },
  {
    id: 152254,
    code: 'overnight',
    cost: 10,
    currency: 'USD',
    selected: false,
    range: {
      min: 1,
      max: 2,
      verb: 'arrive',
      unit: 'business_days',
    },
  },
];
